const userManageEn = {
  userManageLang: {
    账号管理: 'Account management',
    新增账号: 'Add an account',
    请输入内容例如姓名手机邮箱: 'Please enter the content, such as name, mobile phone, email',
    用户类型: 'User type',
    全部: 'All',
    管理员: 'Administrator',
    普通用户: 'Domestic consumer',
    查询: 'Query',
    重置: 'Reset',
    序号: 'Serial Number',
    名称: 'Name',
    邮箱: 'Email',
    手机: 'Mobile phone',
    状态: 'State',
    正常: 'Normal',
    删除: 'Delete',
    禁用: 'Forbidden',
    角色: 'Role',
    创建日期: 'Creation date',
    创建人: 'Founder',
    操作: 'Operation',
    查看: 'Examine',
    编辑: 'Edit',
    请确认是否禁用此账号: 'Please confirm whether to disable this account?',
    请确认是否恢复此账号: 'Please confirm whether to restore this account?',
    恢复: 'Recover',
    更多: 'More',
    重置密码: 'Reset passwords',
    请确认是否删除此账号: 'Please confirm whether to delete this account?',
    暂无数据: 'No data available',
    基础信息: 'Basic information',
    站点分配: 'Site assignment',
    告警配置: 'Alarm configuration',
    邮箱与手机至少填写一项用作为登录账号: 'Fill in at least one item of email and mobile phone as the login account',
    登录邮箱: 'Login email ',
    密码: 'Password',
    请勾选需要分配站点名称: 'Select the site name you want to assign',
    全部站点: 'All sites',
    所有站点包括未来新增站点: 'All sites (including future additions)',
    平台管理员默认管理所有站点包含未来新增站点不再支持站点自由分配:
      'The platform administrator manages all sites by default (including new sites in the future), and no longer supports free allocation of sites!',
    请勾选可查看的处理建议类型: 'Select the solution types that can be viewed',
    全部: 'All',
    取消: 'Cancel',
    确定: 'Confirm',
    查看账号: 'View account',
    账号权限: 'Account authority',
    分配站点: 'Distribution site',

    密码重置: 'Reset the password',
    新密码: 'New password',
    '6-20位字符': '6-20 characters',
    确认密码: 'Confirm password',
    请输入确认密码: 'Please enter the confirmation password!',
    两次密码不一致请重新输入: 'The two passwords are inconsistent. Please re-enter them!',
    请输入密码: 'Please enter password!',
    请输入名称: 'Please enter name!',
    请选择角色: 'Please select roles!',
    请输入手机号码: 'Please enter mobile number!',
    请输入邮箱地址: 'Please enter email address!',
    请选择站点: 'Please select sites!',
    编辑账号: 'Edit account',
    手机号邮箱不可同时为空: 'The email address and mobile phone number cannot be empty at the same time!',

    到期类型: 'Maturity type',
    永久: 'Permanent',
    自定义时间: 'Custom time',
    到期时间: 'Maturity time',
    '7天': '7 days',
    '15天': '15 days',
    '30天': '30 days',
    '6个月': '6 months',
    '1年': '1 year',
    请选择到期时间: 'Please select expiration time!'
  }
}
export default userManageEn
